<template>
  <van-uploader v-model="fileList" :accept="accept" :before-delete="beforeDelete" :max-count="maxCount" :after-read="afterRead" :multiple="multiple" />
</template>

<script>
export default {
  props: {
    value: {
      type: [Array, String],
      required: true
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    maxCount: {
      type: [Number, String],
      required: false,
      default: '-'
    },
    accept: {
      type: String,
      required: false,
      default: 'image/*'
    }
  },
  data() {
    return {
      fileList: []
    }
  },
  created() {
    if (this.value instanceof Array) {
      this.fileList.push(
        ...this.value.map((item) => {
          return { url: item }
        })
      )
    } else {
      if (this.value) {
        this.fileList.push({ url: this.value })
      }
    }
  },
  methods: {
    async afterRead(file) {
      let files = []
      if (Array.isArray(file)) {
        files = file
      } else {
        files.push(file)
      }

      files.forEach(async (item) => {
        item.status = 'uploading'
        item.message = '上传中...'

        let formData = new FormData()
        formData.append('file', item.file)

        const { success, message } = await this.$api.upload('/sys/common/upload', formData)

        if (success) {
          item.status = 'done'
          item.url = message
        } else {
          item.status = 'failed'
          item.message = '上传失败'
        }

        let images = this.fileList.map((item) => item.url)
        if (this.value instanceof Array) {
          this.$emit('input', images)
        } else {
          this.$emit('input', images[0])
        }
      })
    },
    beforeDelete(file) {
      let index = null
      this.fileList.filter((item, i) => {
        if (item.url === file.url) {
          index = i
          return true
        } else {
          return false
        }
      })
      if (index !== null) {
        this.fileList.splice(index, 1)

        let images = this.fileList.map((item) => item.url)
        if (this.value instanceof Array) {
          this.$emit('input', images)
        } else {
          this.$emit('input', images[0])
        }
      }
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/upload/uploadImage.vue